// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"197":"ac3ccdef","275":"2712c1ad","358":"705b5868","368":"1763b127","713":"fdb0d489","823":"742ddfa9","937":"4cad356d"}[chunkId] + ".js";
};